import { MetricAliasStatus } from '../../../types/syntiro_honey';

/**
 * Reviewer-facing presentation of a learned rule's lifecycle status. "Contested"
 * (not the backend's CONFLICTED) matches the review-screen vocabulary: the label
 * received conflicting confirmations and needs an explicit human resolution.
 */
export const ALIAS_STATUS_DISPLAY: Record<
  MetricAliasStatus,
  { label: string; color: 'success' | 'warning' | 'default' }
> = {
  ACTIVE: { label: 'Active', color: 'success' },
  CONFLICTED: { label: 'Contested', color: 'warning' },
  RETIRED: { label: 'Retired', color: 'default' }
};
